import BaseService from "src/packages/BaseService";

export default class ProjectService extends BaseService {
	static get className() {
		return "project";
	}

	static async close(id) {
		let {data} = this.getService().post(`project/close/${id}`);
		return data;
	}

	static async import(formData) {
		let {data} = await this.getService().post("import/measurements", formData);
		return data;
	}
};
